import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-24 lg:py-32 px-8 lg:px-14 bg-arch-cream">
      <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-start">
        {/* Left — Label + headline */}
        <div className="lg:w-5/12 lg:sticky lg:top-32">
          <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-6">About</p>
          <h2 className="font-serif text-4xl lg:text-5xl text-arch-charcoal font-light leading-tight mb-6">
            A studio built<br />on rigor and<br />
            <em>craft.</em>
          </h2>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-arch-charcoal text-white px-7 py-3.5 text-xs tracking-[0.15em] uppercase font-medium hover:bg-arch-black transition-all rounded-md cursor-pointer whitespace-nowrap"
          >
            Our Story
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Right — Content + Images */}
        <div className="lg:w-7/12">
          <p className="text-arch-gray text-base font-light leading-relaxed mb-6">
            Founded in Santa Monica in 2010, Studio 1323 has spent fifteen years building a portfolio of residential, multi-family, and hospitality projects that prioritize authenticity over trend.
          </p>
          <p className="text-arch-gray text-sm font-light leading-relaxed mb-6">
            We work across Los Angeles — from custom hillside homes in Brentwood to boutique hotels in Hermosa Beach to mixed-use developments on the Westside — bringing the same clarity of thought to every scale.
          </p>
          <p className="text-arch-gray text-sm font-light leading-relaxed mb-10">
            Our process is collaborative, transparent, and thorough. We believe clients should understand every decision we make — and we make better decisions when clients are genuinely involved.
          </p>

          {/* Stats row */}
          <div className="grid grid-cols-3 gap-6 mb-10 border-t border-arch-border pt-10">
            {[
              { num: "15+", label: "Years in practice" },
              { num: "60+", label: "Projects completed" },
              { num: "4", label: "Service areas" },
            ].map((stat) => (
              <div key={stat.label}>
                <p className="font-serif text-4xl text-arch-charcoal font-light">{stat.num}</p>
                <p className="text-arch-gray text-xs font-light mt-1 tracking-wide">{stat.label}</p>
              </div>
            ))}
          </div>

          {/* Images */}
          <div className="grid grid-cols-2 gap-4">
            <div className="w-full h-52 overflow-hidden rounded-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/dafce04a0ab37ff365fb19406b046e07.jpg"
                alt="Studio 1323 studio workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-full h-52 overflow-hidden rounded-lg mt-6">
              <img
                src="https://readdy.ai/api/search-image?query=architects%20reviewing%20blueprints%20construction%20documents%2C%20modern%20office%2C%20professional%20team%20collaboration%2C%20architectural%20drawings%20on%20table%2C%20santa%20monica%20california&width=500&height=400&seq=20&orientation=landscape"
                alt="Studio 1323 team at work"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
